module.exports = __webpack_public_path__ + "img/1.bec07b18.png";